import React, { FC, Fragment, useMemo } from 'react';
import { IFilterType } from '../../../../../../../types/ProfileTypes';
import { Dictionary, groupBy, keys } from 'lodash';
import { Col, Row } from 'react-flexbox-grid';
import { DividerStyle } from '../../styled';
import { RenderItems } from '../../RenderFields/RenderItems';

interface IRenderItemsAdvanceHideSection {
  filters: IFilterType[];
  onChange: (value: any) => void;
  beforeKey?: string;
  advance?: boolean;
}

export const RenderItemsAdvanceHideSection: FC<IRenderItemsAdvanceHideSection> = ({
  filters,
  onChange,
  beforeKey,
  advance
}) => {
  const filtersSections: Dictionary<IFilterType[]> = useMemo(() => {
    return groupBy(filters, 'section');
  }, [filters]);

  return (
    <Row style={{ padding: '0' }}>
      {keys(filtersSections).map((key: string, index: number) => (
        <Fragment key={key}>
          {!!index && (
            <Col xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginTop: '5px' }}>
              <DividerStyle />
            </Col>
          )}
          <RenderItems
            {...{ onChange, beforeKey, advance, filters: filtersSections[key], getValueOnSelectMenuItem: true }}
          />
        </Fragment>
      ))}
    </Row>
  );
};
